/**
 * Политика за поверителност на „APP 4 FARMERS" (GDPR).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLayout } from './LegalLayout';
import { COMPANY, ContactBlock } from './company';

const PrivacyPolicyPage = () => (
  <LegalLayout title="Политика за поверителност" active="/privacy-policy">
    <h2>1. Администратор на лични данни</h2>
    <ContactBlock />

    <h2>2. Какви лични данни събираме</h2>

    <h3>2.1. Данни за регистрация и акаунт</h3>
    <ul>
      <li>Потребителско име и/или имейл адрес</li>
      <li>Телефонен номер (по избор)</li>
      <li>Парола (съхранявана само в хеширан вид)</li>
      <li>Име на фирма и ЕИК/Булстат (за бизнес акаунти)</li>
    </ul>

    <h3>2.2. Данни, въведени при ползване на услугата</h3>
    <p>
      Данни за управление на земеделска земя, които може да включват лични данни на трети лица
      (напр. ползватели — физически лица):
    </p>
    <ul>
      <li>Наименование на ползвател, ЕИК/Булстат, лице за контакт</li>
      <li>Землища (ЕКАТТЕ), декларирани площи, доброволни замени (ДЗ), изчертавания</li>
      <li>Бележки и данни, свързани със справките и протоколите</li>
    </ul>

    <h3>2.3. Технически данни</h3>
    <ul>
      <li>IP адрес, тип браузър и устройство</li>
      <li>Дата и час на действие в системата (журнал на действията)</li>
    </ul>

    <h2>3. Правно основание за обработка</h2>
    <ul>
      <li><strong>Договор:</strong> за предоставяне на Услугата съгласно договора с клиента</li>
      <li><strong>Законен интерес:</strong> сигурност, предотвратяване на злоупотреби и подобряване на Услугата</li>
      <li><strong>Съгласие:</strong> за маркетингови съобщения (може да бъде оттеглено по всяко време)</li>
      <li><strong>Законово задължение:</strong> спазване на счетоводни и данъчни изисквания</li>
    </ul>

    <h2>4. Цели на обработката</h2>
    <ul>
      <li>Предоставяне и управление на Услугата {COMPANY.product}</li>
      <li>Фактуриране и изпълнение на договора</li>
      <li>Комуникация относно акаунта и Услугата</li>
      <li>Техническа поддръжка и подобряване на функционалността</li>
      <li>Сигурност и предотвратяване на злоупотреби</li>
      <li>Спазване на законови задължения</li>
    </ul>

    <h2>5. Срокове за съхранение</h2>
    <table>
      <thead>
        <tr>
          <th>Категория данни</th>
          <th>Срок на съхранение</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Данни за акаунт</td>
          <td>Докато акаунтът е активен + 30 дни след прекратяване</td>
        </tr>
        <tr>
          <td>Данни, въведени в Услугата</td>
          <td>Докато акаунтът е активен / съгласно договора</td>
        </tr>
        <tr>
          <td>Фактури и счетоводни данни</td>
          <td>10 години (законово изискване)</td>
        </tr>
        <tr>
          <td>Журнал на действията (логове)</td>
          <td>До 12 месеца</td>
        </tr>
        <tr>
          <td>Маркетингови съгласия</td>
          <td>До оттегляне на съгласието</td>
        </tr>
      </tbody>
    </table>

    <h2>6. Вашите права по GDPR</h2>
    <ul>
      <li><strong>Право на достъп:</strong> да получите копие на Вашите данни</li>
      <li><strong>Право на коригиране:</strong> да коригирате неточни данни</li>
      <li><strong>Право на изтриване:</strong> да поискате изтриване на данните си</li>
      <li><strong>Право на преносимост:</strong> да получите данните в машинночетим формат</li>
      <li><strong>Право на възражение:</strong> срещу обработка на основание легитимен интерес</li>
      <li><strong>Право на оттегляне на съгласие:</strong> за маркетинг по всяко време</li>
    </ul>

    <div className="info-box">
      <h4>Как да упражните правата си</h4>
      <p>
        Свържете се с нас на <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Ще отговорим
        в срок до 30 дни. За данни, въведени от Ваш работодател/организация в системата, се
        обръщайте първо към съответния администратор (виж{' '}
        <Link to="/dpa">DPA</Link>).
      </p>
    </div>

    <h2>7. Получатели на данни</h2>

    <h3>7.1. Доставчици на услуги (Под-обработващи)</h3>
    <table>
      <thead>
        <tr>
          <th>Доставчик</th>
          <th>Цел</th>
          <th>Местоположение</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{COMPANY.hosting}</td>
          <td>Хостинг и съхранение на данни</td>
          <td>{COMPANY.hostingLocation}</td>
        </tr>
      </tbody>
    </table>
    <p>
      Генерирането на документи (PDF протоколи и справки) се извършва изцяло на нашия сървър, без
      използване на външни услуги. Не използваме услуги за анализ на поведение или реклама.
    </p>
    <p>
      Известия на устройството (само ако получателят на публичен линк сам ги разреши): известието
      се доставя през услугата за известия на браузъра или телефона (Google, Apple или Mozilla).
      Съдържанието е шифровано и доставчикът не може да го прочете. Ние пазим само техническия адрес
      за доставка и ключа за шифроване на устройството — без телефонен номер, имейл или име — и ги
      изтриваме при изключване на известията, при нов адрес на линка или при изтриването му.
    </p>

    <h3>7.2. Други получатели</h3>
    <ul>
      <li>Държавни органи (при законово изискване)</li>
      <li>Счетоводни и правни консултанти (при необходимост)</li>
    </ul>

    <h2>8. Международни трансфери</h2>
    <p>
      Данните се хостват в дата центрове в Европейския съюз ({COMPANY.hostingLocation}). Хостинг
      доставчикът ({COMPANY.hosting}) е със седалище в САЩ, поради което при евентуален достъп от
      страна на доставчика се прилагат подходящи защитни мерки съгласно Глава V от GDPR:
    </p>
    <ul>
      <li>Стандартни договорни клаузи (SCC)</li>
      <li>EU-US Data Privacy Framework (DPF), когато е приложимо</li>
    </ul>

    <h2>9. Бисквитки и подобни технологии</h2>
    <p>
      Не използваме проследяващи или рекламни бисквитки, нито инструменти на трети страни за
      анализ на поведение. За поддържане на сесията след вход съхраняваме единствено технически
      необходими данни в браузъра (токен за сесия в localStorage), които се премахват при изход
      или при изчистване на данните на браузъра. Затова не използваме банер за съгласие за
      бисквитки.
    </p>

    <h2>10. Сигурност на данните</h2>
    <ul>
      <li>Криптиране на връзките (HTTPS/TLS)</li>
      <li>Съхранение на паролите само в хеширан вид</li>
      <li>Контрол на достъпа по роли и по землища</li>
      <li>Журнал на действията в системата</li>
      <li>Резервни копия на данните</li>
      <li>Достъп, ограничен до упълномощени лица</li>
    </ul>

    <h2>11. Промени в политиката</h2>
    <p>
      При съществени промени ще Ви уведомим по имейл и/или чрез известие в приложението.
      Продължаването на използването на Услугата означава приемане на актуализираната политика.
    </p>

    <h2>12. Жалби</h2>
    <div className="contact-info">
      <h4>Комисия за защита на личните данни (КЗЛД)</h4>
      <p>Уебсайт: <a href="https://cpdp.bg" target="_blank" rel="noopener noreferrer">cpdp.bg</a></p>
      <p>Email: <a href="mailto:kzld@cpdp.bg">kzld@cpdp.bg</a></p>
      <p>Адрес: София 1592, бул. „Проф. Цветан Лазаров" № 2</p>
    </div>

    <h2>13. Контакт</h2>
    <ContactBlock title="Лице за контакт по защита на данните" />
  </LegalLayout>
);

export default PrivacyPolicyPage;
